import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const pathsRequiringLogin = ['/oma-dixu*', '/myy-asuntosi/aloita-myynti*', '/sign*', '/api*'];
export const ORDER_BY_FILTERS = ['NEWEST_FIRST', 'OLDEST_FIRST'];

// Used in mortgage form
export const EMPLOYMENT_TYPES = ['FULL_TIME', 'PART_TIME', 'PENSIONER', 'ENTEPRENEUR', 'STUDENT', 'UNEMPLOYED', 'FIXED_TIME'];
// Used in mortgage form
export const DWELLING_TYPES = ['RENT', 'OWN', 'RIGHT_OF_OCCUPANCY', 'COMPANY_HOUSING', 'PARTIALLY_OWNED', 'WITH_A_RELATIVE'];

// eslint-disable-next-line prefer-destructuring
export const IMAGE_URL = process.env.IMAGE_URL;
export const LISTING_TYPE = {
  APARTMENT: 'APARTMENT',
  PROPERTY: 'PROPERTY'
};
export const LISTING_PROPERTY_TYPE = {
  FLAT: 'FLAT',
  ROWHOUSE: 'ROWHOUSE',
  PAIRHOUSE: 'PAIRHOUSE',
  SEPARATEHOUSE: 'SEPARATEHOUSE',
  DETACHEDHOUSE: 'DETACHEDHOUSE',
  VACATIONHOME: 'VACATIONHOME',
  LEISUREHOME: 'LEISUREHOME',
  COTTAGE_OR_VILLA: 'COTTAGE_OR_VILLA',
  PLOT: 'PLOT',
  LOFT: 'LOFT',
  VACATION_SHARE: 'VACATION_SHARE',
  DETACHEDHOUSE_PLOT: 'DETACHEDHOUSE_PLOT',
  ROWHOUSE_PLOT: 'ROWHOUSE_PLOT',
  LEISUREHOME_PLOT: 'LEISUREHOME_PLOT',
  APARTMENT_HOUSE_PLOT: 'APARTMENT_HOUSE_PLOT',
  BUSINESS_PLOT: 'BUSINESS_PLOT',
  FARM: 'FARM',
  FOREST_FARM: 'FOREST_FARM',
  FIELD_AREA: 'FIELD_AREA',
  PROPERTY_SCRIPT: 'PROPERTY_SCRIPT',
  WILDERNESS_AREA: 'WILDERNESS_AREA',
  OTHER: 'OTHER',
  OFFICE_SPACE: 'OFFICE_SPACE',
  BUSINESS_SPACE: 'BUSINESS_SPACE',
  PRODUCTION_SPACE: 'PRODUCTION_SPACE',
  STORAGE_SPACE: 'STORAGE_SPACE',
  VACATION_APARTMENT: 'VACATION_APARTMENT',
  WOODEN_HOUSE_SHARE: 'WOODEN_HOUSE_SHARE',
  PLOT_WITHOUT_ZONE: 'PLOT_WITHOUT_ZONE',
  UNBUILT: 'UNBUILT',
  BUILDING: 'BUILDING'
};
export const PROPERTY_TYPE_OPTIONS = [LISTING_PROPERTY_TYPE.FARM, LISTING_PROPERTY_TYPE.PLOT, LISTING_PROPERTY_TYPE.PLOT_WITHOUT_ZONE, LISTING_PROPERTY_TYPE.UNBUILT, LISTING_PROPERTY_TYPE.FOREST_FARM, LISTING_PROPERTY_TYPE.BUILDING];
export const LISTING_TYPE_PROPERTY_OPTIONS = [LISTING_PROPERTY_TYPE.DETACHEDHOUSE, LISTING_PROPERTY_TYPE.ROWHOUSE, LISTING_PROPERTY_TYPE.PAIRHOUSE, LISTING_PROPERTY_TYPE.SEPARATEHOUSE, LISTING_PROPERTY_TYPE.LEISUREHOME, LISTING_PROPERTY_TYPE.COTTAGE_OR_VILLA, LISTING_PROPERTY_TYPE.PLOT];
export const LISTING_TYPE_APARTMENT_OPTIONS = [LISTING_PROPERTY_TYPE.FLAT, LISTING_PROPERTY_TYPE.ROWHOUSE, LISTING_PROPERTY_TYPE.PAIRHOUSE, LISTING_PROPERTY_TYPE.LOFT, LISTING_PROPERTY_TYPE.SEPARATEHOUSE, LISTING_PROPERTY_TYPE.WOODEN_HOUSE_SHARE];
export const LISTING_STATUS = {
  SOLD: 'SOLD',
  ON_SALE: 'ON_SALE',
  DRAFT: 'DRAFT',
  INSPECTION: 'INSPECTION',
  ON_SALE_HIDDEN: 'ON_SALE_HIDDEN',
  SERVICE_AGREEMENT_SIGNED: 'SERVICE_AGREEMENT_SIGNED',
  READY_TO_PUBLISH: 'READY_TO_PUBLISH',
  WAITING_FOR_SELLER_SIGNATURES: 'WAITING_FOR_SELLER_SIGNATURES',
  WAITING_FOR_BUYER_SIGNATURES: 'WAITING_FOR_BUYER_SIGNATURES',
  COMMISSION_SIGNED: 'COMMISSION_SIGNED',
  WAITING_FOR_SERVICE_AGREEMENT_SIGNATURES: 'WAITING_FOR_SERVICE_AGREEMENT_SIGNATURES',
  WAITING_FOR_COMMISSION_SIGNATURES: 'WAITING_FOR_COMMISSION_SIGNATURES',
  WAITING_FOR_DESCRIPTION_ATTACHMENT_SIGNATURES: 'WAITING_FOR_DESCRIPTION_ATTACHMENT_SIGNATURES',
  DESCRIPTION_ATTACHMENT_SIGNED: 'DESCRIPTION_ATTACHMENT_SIGNED',
  RESERVED: 'RESERVED',
  COMMISSION_ENDED: 'COMMISSION_ENDED'
};
export const COMMISSION_STATUS = {
  DONE: 'DONE',
  IN_PROGRESS: 'IN_PROGRESS',
  COMMISSION_SIGNED: 'COMMISSION_SIGNED',
  WAITING_FOR_SIGNATURES: 'WAITING_FOR_SIGNATURES',
  COMMISSION_ARCHIVED: 'COMMISSION_ARCHIVED'
};
export const LOT_OWNERSHIP = {
  OWN: 'OWN',
  RENT: 'RENT',
  OPTIONAL: 'OPTIONAL'
};
export const LOT_TYPE = {
  HILLSIDE_LOT: 'HILLSIDE_LOT',
  FLATLAND_LOT: 'FLATLAND_LOT',
  BEACH_LOT: 'BEACH_LOT'
};
export const BEACH = {
  NO: 'NO',
  OWN: 'OWN',
  OWN_COASTLINE: 'OWN_COASTLINE',
  WATER_AREA_RIGHT: 'WATER_AREA_RIGHT',
  BEACH_RIGHT: 'BEACH_RIGHT',
  COMMUNAL_BEACH: 'COMMUNAL_BEACH'
};
export const OFFER_STATUS = {
  DRAFT: 'DRAFT',
  PROPOSED: 'PROPOSED',
  CANCELLED: 'CANCELLED',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  WAITING_FOR_SELLER_SIGNATURES: 'WAITING_FOR_SELLER_SIGNATURES',
  WAITING_FOR_BUYER_SIGNATURES: 'WAITING_FOR_BUYER_SIGNATURES',
  WAITING_FOR_MANUAL_BUYER_SIGNATURES: 'WAITING_FOR_MANUAL_BUYER_SIGNATURES',
  COUNTER_OFFER_DRAFT: 'COUNTER_OFFER_DRAFT',
  COUNTER_OFFER_MADE: 'COUNTER_OFFER_MADE',
  COUNTER_OFFER_PROPOSED: 'COUNTER_OFFER_PROPOSED',
  COUNTEROFFER_WAITING_FOR_SELLER_SIGNATURES: 'COUNTEROFFER_WAITING_FOR_SELLER_SIGNATURES',
  COUNTEROFFER_WAITING_FOR_BUYER_SIGNATURES: 'COUNTEROFFER_WAITING_FOR_BUYER_SIGNATURES',
  COUNTEROFFER_PROPOSED_TO_BUYER: 'COUNTEROFFER_PROPOSED_TO_BUYER',
  COUNTEROFFER_PROPOSED_TO_SELLER: 'COUNTEROFFER_PROPOSED_TO_SELLER',
  EXPIRED: 'EXPIRED'
};
export const PURCHASE_OFFER_TYPE = {
  INITIAL_OFFER: 'INITIAL_OFFER',
  COUNTER_OFFER: 'COUNTER_OFFER'
};
export const PRESENTATION_TYPE = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  AVAILABLE_SLOT: 'AVAILABLE_SLOT',
  FIRST_SHOWING: 'FIRST_SHOWING'
};
export const PUBLIC_PRESENTATION_TYPES = [PRESENTATION_TYPE.PUBLIC, PRESENTATION_TYPE.FIRST_SHOWING];
export const CONDITION_CHECK_TYPE = {
  SELLER: 'SELLER',
  BUYER: 'BUYER',
  SPLIT: 'SPLIT'
};
export const SERVICE_PACKAGE = {
  DIXU_PLUS: 'DIXU_PLUS',
  DIXU_EASY: 'DIXU_EASY'
};
export const PURCHASE_OFFER_USER_TYPES = {
  BUYER: 'BUYER',
  SELLER: 'SELLER'
};
export const MATERIAL = {
  PARQUET: 'PARQUET',
  LAMINATE: 'LAMINATE',
  PLASTIC: 'PLASTIC',
  PAINT: 'PAINT',
  WALLPAPER: 'WALLPAPER',
  TILE: 'TILE',
  CERAMICTILE: 'CERAMICTILE',
  FELT: 'FELT',
  SHEET: 'SHEET',
  BRICK: 'BRICK',
  CONCRETE: 'CONCRETE',
  LOG: 'LOG',
  WOOD: 'WOOD',
  BRICKCLADDING: 'BRICKCLADDING',
  OTHER: 'OTHER',
  STONE: 'STONE',
  HALF_PANEL: 'HALF_PANEL',
  PANEL: 'PANEL',
  PARTIAL_TILING: 'PARTIAL_TILING',
  BOARD: 'BOARD',
  GLASS_FIBER_WALLPAPER: 'GLASS_FIBER_WALLPAPER',
  RUBBER_BITUMEN: 'RUBBER_BITUMEN',
  VINYL: 'VINYL',
  QUARTZ_COMPOSITE: 'QUARTZ_COMPOSITE',
  PANEL_HOUSE: 'PANEL_HOUSE',
  ELEMENT_HOUSE: 'ELEMENT_HOUSE',
  TERNE_PLATE: 'TERNE_PLATE',
  ETERNIT: 'ETERNIT',
  PROFILE_SHEET_METAL: 'PROFILE_SHEET_METAL',
  WOOD_SHINGLE: 'WOOD_SHINGLE',
  HAY_GRASS: 'HAY_GRASS'
};
export const ZONING_STATUS = {
  CITY_PLAN: 'CITY_PLAN',
  DISPERSED_SETTLEMENT: 'DISPERSED_SETTLEMENT',
  NOT_ZONED: 'NOT_ZONED',
  DEPLOYMENT_INSPECTION: 'DEPLOYMENT_INSPECTION',
  FINAL_INSPECTION: 'FINAL_INSPECTION',
  PART_ZONING_PLAN: 'PART_ZONING_PLAN',
  DEVIATION_DECISION: 'DEVIATION_DECISION',
  BUILDING_PLANS: 'BUILDING_PLANS',
  BUILDING_BAN: 'BUILDING_BAN',
  BUILDING_PERMIT: 'BUILDING_PERMIT',
  BEACH_CITY_PLAN: 'BEACH_CITY_PLAN',
  BEACH_PLAN: 'BEACH_PLAN',
  PLANNING_NEED_AREA: 'PLANNING_NEED_AREA',
  OPERATION_BAN: 'OPERATION_BAN',
  ZONING_PLAN: 'ZONING_PLAN'
};
export const PROPERTY_ZONING_STATUSES = [ZONING_STATUS.CITY_PLAN, ZONING_STATUS.ZONING_PLAN, ZONING_STATUS.BEACH_PLAN, ZONING_STATUS.NOT_ZONED];
export const PURCHASE_OFFER_PROPOSER = {
  SELLER: 'SELLER',
  BUYER: 'BUYER'
};
export const FINNISH_DATE_FORMAT = 'D.M.YYYY';
export const FINNISH_DAY_AND_DATE_FORMAT = 'dd D.M.YYYY';
export const FINNISH_LONG_DAY_AND_DATE_FORMAT = 'dddd D.M.YYYY';
export const FINNISH_DATETIME_FORMAT = 'D.M.YYYY HH:mm';
export const HHmmFormat = 'HH:mm';
export const VAT_PERCENTAGE = 0.24;
export const DIXU_INITIAL_BILL_EUROS = '495';
export const COUPON_TYPES = {
  DIXU: 'DIXU',
  INSPIRATION: 'INSPIRATION'
};
export const AreaBasis = {
  BY_LAWS: 'BY_LAWS',
  PROPERTY_MANAGER: 'PROPERTY_MANAGER'
};
export const PRODUCT_GROUP = {
  VACATION_APARTMENT: 'VACATION_APARTMENT',
  RENT_APARTMENT: 'RENT_APARTMENT',
  NEWLY_CONSTRUCTED: 'NEWLY_CONSTRUCTED',
  BUSINESS_PREMISES: 'BUSINESS_PREMISES',
  APARTMENTS: 'APARTMENTS',
  PLOTS: 'PLOTS',
  FARMS: 'FARMS'
};
export const DISCOUNT_TYPES = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED: 'FIXED'
};
export const DOCUMENT_TYPE = {
  SALE_ADVERTISEMENT: 'SALE_ADVERTISEMENT',
  HOUSING_MANAGER_CERTIFICATE: 'HOUSING_MANAGER_CERTIFICATE',
  FINANCIAL_STATEMENT: 'FINANCIAL_STATEMENT',
  MAINTENANCE_PLAN: 'MAINTENANCE_PLAN',
  ENERGY_CERTIFICATE: 'ENERGY_CERTIFICATE',
  BY_LAWS: 'BY_LAWS',
  BUDGET: 'BUDGET',
  PROPERTY_DOCUMENT: 'PROPERTY_DOCUMENT',
  OTHER: 'OTHER',
  COMMISSION: 'COMMISSION',
  DESCRIPTION_ATTACHMENT: 'DESCRIPTION_ATTACHMENT',
  INVOICE: 'INVOICE',
  DIAS_BILL_OF_SALE: 'DIAS_BILL_OF_SALE',
  DIAS_ATTACHMENT: 'DIAS_ATTACHMENT',
  DIAS_SIGNED_DOCUMENT: 'DIAS_SIGNED_DOCUMENT',
  COMMISSION_CANCELLATION_ATTACHMENT: 'COMMISSION_CANCELLATION_ATTACHMENT',
  PEP_FORM: 'PEP_FORM',
  PROPERTY_MANAGER_COMMISSION: 'PROPERTY_MANAGER_COMMISSION',
  PURCHASE_OFFER: 'PURCHASE_OFFER',
  PURCHASE_OFFER_CUSTOM_DOCUMENT: 'PURCHASE_OFFER_CUSTOM_UNSIGNED_DOCUMENT',
  COMMISSION_CUSTOM_DOCUMENT: 'COMMISSION_CUSTOM_DOCUMENT',
  DESCRIPTION_ATTACHMENT_CUSTOM_DOCUMENT: 'DESCRIPTION_ATTACHMENT_CUSTOM_DOCUMENT',
  RENTAL_CONTRACT: 'RENTAL_CONTRACT',
  REAL_BENEFICIARIES_FORM: 'REAL_BENEFICIARIES_FORM',
  PROPERTY_PRINTED_MAP: 'PROPERTY_PRINTED_MAP',
  PROPERTY_BASIC_INFO: 'PROPERTY_BASIC_INFO',
  PROPERTY_LEASEHOLD: 'PROPERTY_LEASEHOLD',
  EXTRACT_FROM_THE_CADASTRE: 'EXTRACT_FROM_THE_CADASTRE',
  PROPERTY_REAL_REGISTER_EXTRACT: 'PROPERTY_REAL_REGISTER_EXTRACT',
  CERTIFICATE_OF_MORTGAGES_AND_ENCUMBRANCES: 'CERTIFICATE_OF_MORTGAGES_AND_ENCUMBRANCES',
  CERTIFICATE_OF_LEASEHOLD: 'CERTIFICATE_OF_LEASEHOLD'
};
export const DOCUMENT_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED'
};
export const DIXU_CONTACT_INFO = {
  address: 'Kalevankatu 30',
  city: 'Helsinki',
  postalCode: '00100',
  businessID: '2880878-1',
  email: 'info@dixu.fi',
  tel: '09 74792800',
  facebook: 'https://www.facebook.com/DIXU-184679968945461/',
  instagram: 'https://www.instagram.com/dixukodit/',
  linkedin: 'https://www.linkedin.com/company/dixu',
  whatsapp: '',
  twitter: ''
};
export const CONSTRUCTION_MATERIALS = [MATERIAL.CONCRETE, MATERIAL.WOOD, MATERIAL.BRICK, MATERIAL.BRICKCLADDING, MATERIAL.LOG, MATERIAL.ELEMENT_HOUSE, MATERIAL.PANEL_HOUSE, MATERIAL.STONE];
export const PROPERTY_BUILDINGS = {
  GARAGE: 'GARAGE',
  CARPORT: 'CARPORT',
  PLAYHOUSE: 'PLAYHOUSE',
  WOODSHED: 'WOODSHED'
};
export const HEATING_SYSTEMS = ['ELECTRIC', 'DISTRICT', 'GROUND', 'WOOD', 'OIL', 'AIR_SOURCE_HEAT_PUMP', 'EXHAUST_AIR_HEAT_PUMP', 'GAS', 'SUN', 'AIR_WATER_HEAT_PUMP', 'BOILER', 'FLOOR_HEATING', 'CEILING_HEATING', 'LIQUID_GAS', 'BIOGAS', 'WOOD_PELLET', 'WOOD_CHIP', 'COAL'];
export const ROOF_TYPES = ['FLAT', 'GABLED', 'PENTROOF'];
export const ROOFING_MATERIALS = [MATERIAL.FELT, MATERIAL.SHEET, MATERIAL.BRICK, MATERIAL.RUBBER_BITUMEN];
export const ANTENNA_SYSTEMS = ['ANTENNA', 'CABLE'];
export const TELECOMMUNICATION_SYSTEMS = ['TELEPHONE_NETWORK', 'GENERIC_CABLE', 'FIBER_OPTIC_CABLE'];
export const KITCHEN_EQUIPMENT = ['FRIDGE', 'FREEZER', 'FRIDGE_FREEZER', 'FRIDGE_COOLER', 'YANKEE_FRIDGE_FREEZER', 'COOLER', 'OVEN', 'SEPARATE_OVEN', 'STOVE', 'KITCHENHOOD', 'MICROWAVE', 'DISHWASHER', 'KITCHEN_ISLAND'];
export const STOVES = ['CERAMIC', 'GAS', 'INDUCTION', 'CASTIRON', 'ELECTRIC_STOVE', 'WOOD_STOVE', 'HALOGEN'];
export const KITCHEN_WALL_MATERIAL = ['TILE', 'CERAMICTILE', 'PAINT', 'WALLPAPER', 'WOOD', 'LOG'];
export const KITCHEN_FLOOR_MATERIAL = ['TILE', 'CERAMICTILE', 'PLASTIC', 'LAMINATE', 'PARQUET', 'VINYL', 'CONCRETE', 'BOARD', 'STONE'];
export const KITCHEN_TOPS = ['WOOD', 'STONE', 'LAMINATE', 'QUARTZ_COMPOSITE'];
export const BATHROOM_FLOOR_MATERIAL = ['STONE', 'PLASTIC', 'TILE', 'VINYL', 'CONCRETE'];
export const BATHROOM_WALL_MATERIAL = ['STONE', 'CERAMICTILE', 'PAINT', 'WOOD', 'PLASTIC', 'PARTIAL_TILING', 'HALF_PANEL', 'PANEL', 'BOARD', 'LOG'];
export const SAUNA_STOVES = ['WOOD', 'ELECTRIC', 'INSTANT'];
export const SAUNA_FLOOR_MATERIAL = ['STONE', 'TILE', 'BOARD', 'CONCRETE'];
export const SAUNA_WALL_MATERIAL = ['STONE', 'CERAMICTILE', 'PAINT', 'WOOD', 'HALF_PANEL', 'PANEL', 'PARTIAL_TILING'];
export const WC_FLOOR_MATERIAL = ['STONE', 'TILE', 'BOARD', 'PLASTIC', 'VINYL', 'CONCRETE'];
export const WC_WALL_MATERIAL = ['PAINT', 'CERAMICTILE', 'WOOD', 'HALF_PANEL', 'PANEL', 'WALLPAPER', 'GLASS_FIBER_WALLPAPER', 'PARTIAL_TILING', 'LOG'];
export const UTILITY_ROOM_FLOOR_MATERIAL = ['STONE', 'TILE', 'BOARD', 'PLASTIC', 'LAMINATE', 'VINYL', 'CONCRETE'];
export const UTILITY_ROOM_WALL_MATERIAL = ['PAINT', 'CERAMICTILE', 'WOOD', 'WALLPAPER', 'GLASS_FIBER_WALLPAPER', 'PARTIAL_TILING', 'HALF_PANEL', 'PANEL', 'LOG'];
export const LIVING_ROOM_FLOOR_MATERIAL = ['STONE', 'TILE', 'BOARD', 'PLASTIC', 'LAMINATE', 'PARQUET', 'VINYL', 'CONCRETE'];
export const LIVING_ROOM_WALL_MATERIAL = ['PAINT', 'WOOD', 'GLASS_FIBER_WALLPAPER', 'HALF_PANEL', 'PANEL', 'WALLPAPER', 'PARTIAL_TILING', 'LOG'];
export const BEDROOM_FLOOR_MATERIAL = ['TILE', 'BOARD', 'PLASTIC', 'LAMINATE', 'PARQUET', 'VINYL', 'CONCRETE', 'STONE'];
export const BEDROOM_WALL_MATERIAL = ['PAINT', 'WOOD', 'GLASS_FIBER_WALLPAPER', 'HALF_PANEL', 'PANEL', 'WALLPAPER', 'PARTIAL_TILING', 'CERAMICTILE', 'LOG'];
export const BATHROOM_EQUIPMENT = {
  TOILET_SEAT: 'TOILET_SEAT',
  SHOWER: 'SHOWER',
  BATHTUB: 'BATHTUB',
  HOT_TUB: 'HOT_TUB',
  SHOWER_SCREEN: 'SHOWER_SCREEN',
  SHOWER_CUBICLE: 'SHOWER_CUBICLE',
  WASHING_MACHINE: 'WASHING_MACHINE',
  DRYER: 'DRYER',
  WASHING_MACHINE_CONNECTION: 'WASHING_MACHINE_CONNECTION',
  DRYING_CABINET: 'DRYING_CABINET',
  UNDERFLOOR_HEATING: 'UNDERFLOOR_HEATING',
  MIRROR_CABINET: 'MIRROR_CABINET',
  MIRROR: 'MIRROR',
  SINK: 'SINK',
  SINK_CABINET: 'SINK_CABINET',
  BIDEE: 'BIDEE'
};
export const WC_EQUIPMENT = _objectSpread(_objectSpread({}, BATHROOM_EQUIPMENT), {}, {
  FLOOR_DRAIN: 'FLOOR_DRAIN'
});
export const UTILITY_ROOM_EQUIPMENT = {
  WASHING_MACHINE: 'WASHING_MACHINE',
  DRYER: 'DRYER',
  WASHING_MACHINE_CONNECTION: 'WASHING_MACHINE_CONNECTION',
  DRYING_CABINET: 'DRYING_CABINET',
  UNDERFLOOR_HEATING: 'UNDERFLOOR_HEATING',
  SINK: 'SINK',
  FLOOR_DRAIN: 'FLOOR_DRAIN',
  CHILDCARE_TABLE: 'CHILDCARE_TABLE',
  IRONING_TABLE: 'IRONING_TABLE',
  LAUNDRY_CABINET: 'LAUNDRY_CABINET',
  DIRT_STATION: 'DIRT_STATION',
  TABLETOP: 'TABLETOP',
  CENTRAL_VACUUM: 'CENTRAL_VACUUM',
  ROOM_FOR_SCRUBBER: 'ROOM_FOR_SCRUBBER',
  WALL_RADIATOR: 'WALL_RADIATOR'
};
export const FIREPLACE = {
  FIREPLACE: 'FIREPLACE',
  FIREPLACE_OPTION: 'FIREPLACE_OPTION',
  FIREPLACE_HEATSTORING: 'FIREPLACE_HEATSTORING',
  CONDUIT_EXISTS: 'CONDUIT_EXISTS',
  NO_FIREPLACE: 'NO_FIREPLACE'
};
export const OTHER_SPACES = {
  STUDY: 'STUDY',
  DINING_ROOM: 'DINING_ROOM',
  HALLWAY: 'HALLWAY',
  WIND_BOX: 'WIND_BOX',
  BOILER_ROOM: 'BOILER_ROOM',
  LOBBY: 'LOBBY',
  FIREPLACE_ROOM: 'FIREPLACE_ROOM',
  LIBRARY: 'LIBRARY',
  TERRACE: 'TERRACE',
  PATIO: 'PATIO',
  BALCONY: 'BALCONY'
};
export const TRAFFIC_CONNECTION = {
  BUS: 'BUS',
  METRO: 'METRO',
  TRAIN: 'TRAIN',
  CAR: 'CAR',
  TAXI: 'TAXI',
  AIRPORT: 'AIRPORT',
  GOOD_CYCLEWAY: 'GOOD_CYCLEWAY',
  TRAM: 'TRAM'
};
export const RELEASE = {
  CONTRACT: 'CONTRACT',
  IMMEDIATELY: 'IMMEDIATELY',
  DATE: 'DATE',
  OTHER: 'OTHER'
};
export const OwnershipType = {
  OWNER: 'OWNER',
  LEASE: 'LEASE',
  FRACTIONAL: 'FRACTIONAL',
  // ESTONIAN
  COMMON_OWNERSHIP: 'COMMON_OWNERSHIP',
  BUILDING_RIGHT: 'BUILDING_RIGHT',
  HOUSING_ASSOCIATION: 'HOUSING_ASSOCIATION',
  MOVABLE: 'MOVABLE',
  APARTMENT_OWNERSHIP: 'APARTMENT_OWNERSHIP',
  IMMOVABLE: 'IMMOVABLE'
};
export const NEW_DEVELOPMENT_STATUS = {
  IN_PLANNING: 'IN_PLANNING',
  PRE_MARKETING: 'PRE_MARKETING',
  UNDER_CONSTRUCTION: 'UNDER_CONSTRUCTION',
  READY_TO_MOVE: 'READY_TO_MOVE'
};
export const STORAGE_SPACE = {
  COOLED_CELLAR: 'COOLED_CELLAR',
  WALK_IN_WARDROBE: 'WALK_IN_WARDROBE',
  OUTSIDE_STORAGE: 'OUTSIDE_STORAGE',
  CABINETS: 'CABINETS',
  CELLAR_CLOSET: 'CELLAR_CLOSET',
  ATTIC_CLOSET: 'ATTIC_CLOSET',
  ATTIC: 'ATTIC',
  CAGE_STORAGE: 'CAGE_STORAGE',
  ROOT_CELLAR: 'ROOT_CELLAR',
  WALL_CUPBOARD: 'WALL_CUPBOARD'
};
export const LISTING_CONDITION = ['NEW', 'EXCELLENT', 'GOOD', 'AVERAGE', 'BAD'];
export const BALCONY = {
  GLASSED: 'GLASSED',
  FRENCH: 'FRENCH',
  PROTRUDING: 'PROTRUDING',
  // Ulostyönnetty
  RECESSED: 'RECESSED' // Sisäänvedetty
};
export const COMPASS_POINT = {
  NORTH: 'NORTH',
  EAST: 'EAST',
  SOUTH: 'SOUTH',
  WEST: 'WEST',
  NORTH_EAST: 'NORTH_EAST',
  NORTH_WEST: 'NORTH_WEST',
  SOUTH_EAST: 'SOUTH_EAST',
  SOUTH_WEST: 'SOUTH_WEST'
};
export const LOT_SALES_TYPE = {
  ENTIRE_LOT: 'ENTIRE_LOT',
  SPECIFIED_SHARE: 'SPECIFIED_SHARE',
  UNSEPARATED_PARCEL: 'UNSEPARATED_PARCEL'
};
export const PROPERTY_MAINTENANCE = {
  MAINTENANCE_COMPANY: 'MAINTENANCE_COMPANY',
  RESIDENTS: 'RESIDENTS',
  JANITOR: 'JANITOR'
};
export const PROPERTY_HAS = {
  CONDUIT: 'CONDUIT',
  COOLED_CELLAR: 'COOLED_CELLAR',
  CRAFTS_ROOM: 'CRAFTS_ROOM',
  CABLE_TV: 'CABLE_TV',
  CELLAR_CLOSET: 'CELLAR_CLOSET',
  DRYING_ROOM: 'DRYING_ROOM',
  MANGLE: 'MANGLE',
  SATELLITE_ANTENNA: 'SATELLITE_ANTENNA',
  SAUNA: 'SAUNA',
  SWIMMING_POOL: 'SWIMMING_POOL',
  SPORTS_EQUIPMENT_STORAGE: 'SPORTS_EQUIPMENT_STORAGE',
  ATTIC_CLOSET: 'ATTIC_CLOSET',
  SHELTER: 'SHELTER',
  BICYCLE_STORAGE: 'BICYCLE_STORAGE',
  LAUNDRY_ROOM: 'LAUNDRY_ROOM',
  OUTDOOR_STORAGE: 'OUTDOOR_STORAGE',
  PRAM_STORAGE: 'PRAM_STORAGE'
};
export const HOUSING_COOP_HAS = [PROPERTY_HAS.ATTIC_CLOSET, PROPERTY_HAS.CABLE_TV, PROPERTY_HAS.CELLAR_CLOSET, PROPERTY_HAS.CONDUIT, PROPERTY_HAS.CRAFTS_ROOM, PROPERTY_HAS.DRYING_ROOM, PROPERTY_HAS.MANGLE, PROPERTY_HAS.SATELLITE_ANTENNA, PROPERTY_HAS.SHELTER, PROPERTY_HAS.SPORTS_EQUIPMENT_STORAGE, PROPERTY_HAS.SWIMMING_POOL, PROPERTY_HAS.COOLED_CELLAR, PROPERTY_HAS.BICYCLE_STORAGE, PROPERTY_HAS.LAUNDRY_ROOM];
export const PARKING_SPACE = {
  YARD: 'YARD',
  YARD_PLUG: 'YARD_PLUG',
  GARAGE: 'GARAGE',
  SHED: 'SHED',
  SHED_PLUG: 'SHED_PLUG'
};
export const CONSTRUCTION_PHASE = {
  ADVANCE_MARKETING: 'ADVANCE_MARKETING',
  UNDER_CONSTRUCTION: 'UNDER_CONSTRUCTION',
  FINISHED: 'FINISHED',
  FOUNDATION_BUILT: 'FOUNDATION_BUILT',
  // Perustukset
  FRAME_COMPLETE: 'FRAME_COMPLETE',
  // Runko pystyssä, odottaa katon asennusta
  ROOFED_STRUCTURE: 'ROOFED_STRUCTURE',
  // Katto asennettu
  ENCLOSED_STRUCTURE: 'ENCLOSED_STRUCTURE' // Katto ja ikkunat asennettu
};
export const FINNISH_MUNICIPALITIES = ['Akaa', 'Alajärvi', 'Alavieska', 'Alavus', 'Asikkala', 'Askola', 'Aura', 'Brändö', 'Eckerö', 'Enonkoski', 'Enontekiö', 'Espoo', 'Eura', 'Eurajoki', 'Evijärvi', 'Finström', 'Forssa', 'Föglö', 'Geta', 'Haapajärvi', 'Haapavesi', 'Hailuoto', 'Halsua', 'Hamina', 'Hammarland', 'Hankasalmi', 'Hanko', 'Harjavalta', 'Hartola', 'Hattula', 'Hausjärvi', 'Heinola', 'Heinävesi', 'Helsinki', 'Hirvensalmi', 'Hollola', 'Huittinen', 'Humppila', 'Hyrynsalmi', 'Hyvinkää', 'Hämeenkyrö', 'Hämeenlinna', 'Ii', 'Iisalmi', 'Iitti', 'Ikaalinen', 'Ilmajoki', 'Ilomantsi', 'Imatra', 'Inari', 'Inkoo', 'Isojoki', 'Isokyrö', 'Janakkala', 'Joensuu', 'Jokioinen', 'Jomala', 'Joroinen', 'Joutsa', 'Juuka', 'Juupajoki', 'Juva', 'Jyväskylä', 'Jämijärvi', 'Jämsä', 'Järvenpää', 'Kaarina', 'Kaavi', 'Kajaani', 'Kalajoki', 'Kangasala', 'Kangasniemi', 'Kankaanpää', 'Kannonkoski', 'Kannus', 'Karijoki', 'Karkkila', 'Karstula', 'Karvia', 'Kaskinen', 'Kauhajoki', 'Kauhava', 'Kauniainen', 'Kaustinen', 'Keitele', 'Kemi', 'Kemijärvi', 'Keminmaa', 'Kemiönsaari', 'Kempele', 'Kerava', 'Keuruu', 'Kihniö', 'Kinnula', 'Kirkkonummi', 'Kitee', 'Kittilä', 'Kiuruvesi', 'Kivijärvi', 'Kokemäki', 'Kokkola', 'Kolari', 'Konnevesi', 'Kontiolahti', 'Korsnäs', 'Koski Tl', 'Kotka', 'Kouvola', 'Kristiinankaupunki', 'Kruunupyy', 'Kuhmo', 'Kuhmoinen', 'Kumlinge', 'Kuopio', 'Kuortane', 'Kurikka', 'Kustavi', 'Kuusamo', 'Kyyjärvi', 'Kärkölä', 'Kärsämäki', 'Kökar', 'Lahti', 'Laihia', 'Laitila', 'Lapinjärvi', 'Lapinlahti', 'Lappajärvi', 'Lappeenranta', 'Lapua', 'Laukaa', 'Lemi', 'Lemland', 'Lempäälä', 'Leppävirta', 'Lestijärvi', 'Lieksa', 'Lieto', 'Liminka', 'Liperi', 'Lohja', 'Loimaa', 'Loppi', 'Loviisa', 'Luhanka', 'Lumijoki', 'Lumparland', 'Luoto', 'Luumäki', 'Maalahti', 'Maarianhamina', 'Marttila', 'Masku', 'Merijärvi', 'Merikarvia', 'Miehikkälä', 'Mikkeli', 'Muhos', 'Multia', 'Muonio', 'Mustasaari', 'Muurame', 'Mynämäki', 'Myrskylä', 'Mäntsälä', 'Mänttä-Vilppula', 'Mäntyharju', 'Naantali', 'Nakkila', 'Nivala', 'Nokia', 'Nousiainen', 'Nurmes', 'Nurmijärvi', 'Närpiö', 'Orimattila', 'Oripää', 'Orivesi', 'Oulainen', 'Oulu', 'Outokumpu', 'Padasjoki', 'Paimio', 'Paltamo', 'Parainen', 'Parikkala', 'Parkano', 'Pedersören kunta', 'Pelkosenniemi', 'Pello', 'Perho', 'Pertunmaa', 'Petäjävesi', 'Pieksämäki', 'Pielavesi', 'Pietarsaari', 'Pihtipudas', 'Pirkkala', 'Polvijärvi', 'Pomarkku', 'Pori', 'Pornainen', 'Porvoo', 'Posio', 'Pudasjärvi', 'Pukkila', 'Punkalaidun', 'Puolanka', 'Puumala', 'Pyhtää', 'Pyhäjoki', 'Pyhäjärvi', 'Pyhäntä', 'Pyhäranta', 'Pälkäne', 'Pöytyä', 'Raahe', 'Raasepori', 'Raisio', 'Rantasalmi', 'Ranua', 'Rauma', 'Rautalampi', 'Rautavaara', 'Rautjärvi', 'Reisjärvi', 'Riihimäki', 'Ristijärvi', 'Rovaniemi', 'Ruokolahti', 'Ruovesi', 'Rusko', 'Rääkkylä', 'Saarijärvi', 'Salla', 'Salo', 'Saltvik', 'Sastamala', 'Sauvo', 'Savitaipale', 'Savonlinna', 'Savukoski', 'Seinäjoki', 'Sievi', 'Siikainen', 'Siikajoki', 'Siikalatva', 'Siilinjärvi', 'Simo', 'Sipoo', 'Siuntio', 'Sodankylä', 'Soini', 'Somero', 'Sonkajärvi', 'Sotkamo', 'Sottunga', 'Sulkava', 'Sund', 'Suomussalmi', 'Suonenjoki', 'Sysmä', 'Säkylä', 'Taipalsaari', 'Taivalkoski', 'Taivassalo', 'Tammela', 'Tampere', 'Tervo', 'Tervola', 'Teuva', 'Tohmajärvi', 'Toholampi', 'Toivakka', 'Tornio', 'Turku', 'Tuusniemi', 'Tuusula', 'Tyrnävä', 'Ulvila', 'Urjala', 'Utajärvi', 'Utsjoki', 'Uurainen', 'Uusikaarlepyy', 'Uusikaupunki', 'Vaala', 'Vaasa', 'Valkeakoski', 'Vantaa', 'Varkaus', 'Vehmaa', 'Vesanto', 'Vesilahti', 'Veteli', 'Vieremä', 'Vihti', 'Viitasaari', 'Vimpeli', 'Virolahti', 'Virrat', 'Vårdö', 'Vöyri', 'Ylitornio', 'Ylivieska', 'Ylöjärvi', 'Ypäjä', 'Ähtäri', 'Äänekoski'];
export const ListingSalesMethod = {
  TRADITIONAL: 'TRADITIONAL',
  BIDDING: 'BIDDING'
};
export const HumidityInspectionPayerType = {
  SELLER: 'SELLER',
  BUYER: 'BUYER',
  SPLIT: 'SPLIT'
};
export const VideoType = {
  VIDEO: 'VIDEO',
  DRONE: 'DRONE'
};
export const SpecifiedShareDefinition = {
  MAP_ATTACHMENT: 'MAP_ATTACHMENT',
  TERRAIN_MARKED: 'TERRAIN_MARKED'
};
export const ApartmentPurchaseOfferDocumentTypes = {
  SALES_LEAFLET: 'SALES_LEAFLET',
  // Myyntiesite
  HOUSING_MANAGER_CERTIFICATE: 'HOUSING_MANAGER_CERTIFICATE',
  // Isännöitsijäntodistus

  // Not useful for offer, keep option
  // PRINTOUT_OF_OWNER_APARTMENTS: 'PRINTOUT_OF_OWNER_APARTMENTS', // Osakehuoneistotuloste

  // Not useful for offer, keep option
  // PRINTOUT_OF_SHARE_LIST: 'PRINTOUT_OF_SHARE_LIST', // Osakeluettelotuloste

  BY_LAWS: 'BY_LAWS',
  // Yhtiöjärjestys

  ENERGY_CERTIFICATE: 'ENERGY_CERTIFICATE',
  // Energiatodistus

  REPORT_ON_MAINTENANCE_NEEDS: 'REPORT_ON_MAINTENANCE_NEEDS',
  // Kunnossapitotarveselvitys
  FLOOR_PLAN: 'FLOOR_PLAN',
  FINANCIAL_STATEMENTS: 'FINANCIAL_STATEMENTS',
  // Tilinpäätösasiakirjat

  BUDGET: 'BUDGET',
  // Talousarvio

  ASBESTOS_SURVEY: 'ASBESTOS_SURVEY',
  HUMIDITY_INSPECTION: 'HUMIDITY_INSPECTION',
  HOUSING_COOP_CONDITION_STATEMENT: 'HOUSING_COOP_CONDITION_STATEMENT',
  PTS: 'PTS',
  MAINTENANCE_PLAN: 'MAINTENANCE_PLAN',
  APARTMENT_REPAIR_STATEMENT: 'APARTMENT_REPAIR_STATEMENT',
  RENTAL_CONTRACT: 'RENTAL_CONTRACT',
  // Vuokrasopimus,

  AREA_CONTROL_MEASURING_RECORD: 'AREA_CONTROL_MEASURING_RECORD',
  // Pinta-alan mittauspöytäkirja

  APARTMENT_CONDITION_STATEMENT_SIGNED_BY_SELLER: 'APARTMENT_CONDITION_STATEMENT_SIGNED_BY_SELLER',
  // Myyjän allekirjoittama selvitys asunnon kunnosta ym ,

  CERTIFICATE_OF_OWNERSHIP: 'CERTIFICATE_OF_OWNERSHIP',
  // Lainhuutotodistus
  CERTIFICATE_OF_MORTGAGES_AND_ENCUMBRANCES: 'CERTIFICATE_OF_MORTGAGES_AND_ENCUMBRANCES',
  // Rasitustodistus
  EXTRACT_OF_CADASTRE: 'EXTRACT_OF_CADASTRE',
  // Kiinteistörekisteriote
  OTHER_DOCUMENTS: 'OTHER_DOCUMENTS' // Muu
};
export const BudgetConfirmedTypes = {
  CONFIRMED: 'CONFIRMED',
  UNCONFIRMED: 'UNCONFIRMED'
};
export const DamageLocation = {
  HOUSING_COOPERATIVE: 'HOUSING_COOPERATIVE',
  APARTMENT: 'APARTMENT'
};
export const ListingHasEnergyCertificate = {
  YES: 'YES',
  NO_BUT_REQUIRED_BY_LAW: 'NO_BUT_REQUIRED_BY_LAW',
  NOT_REQUIRED_BY_LAW: 'NOT_REQUIRED_BY_LAW'
};
export const EnergyClass = ['A2007', 'B2007', 'C2007', 'D2007', 'E2007', 'F2007', 'G2007', 'A2013', 'B2013', 'C2013', 'D2013', 'E2013', 'F2013', 'G2013', 'A2018', 'B2018', 'C2018', 'D2018', 'E2018', 'F2018', 'G2018'];
export const IS_AWARE = {
  YES: 'YES',
  NO: 'NO',
  NO_ACCOUNT: 'NO_ACCOUNT'
};
export const ContactInfoSource = {
  REALTOR: 'REALTOR',
  OFFICE: 'OFFICE'
};
export const HousingCooperativeMortgageType = {
  PROPERTY_MANAGER_CERTIFICATE_DATE: 'PROPERTY_MANAGER_CERTIFICATE_DATE',
  DATE: 'DATE'
};
export const ChargeCalculationBasis = {
  AREA: 'AREA',
  SHARE_COUNT: 'SHARE_COUNT'
};
export const CountriesInLinear = {
  FI: 'FI',
  EE: 'EE'
};
export const LanguageInLinear = {
  fi: 'fi',
  en: 'en',
  et: 'et'
};
export const LotAreaUnit = {
  SQUARE_METER: 'SQUARE_METER',
  HECTARE: 'HECTARE'
};